import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Fieldset} from "primereact/fieldset";
import PurchaseOrderItemMobileListColumn
    from "../../shared/component/dataTable/columns/PurchaseOrderItemMobileListColumn.json";
import {Button, Col, Label, Row} from "reactstrap";
import Translate from "../../shared/language/Translate";
import {toast} from "react-toastify";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import LicenseService from "../../shared/service/LicenseService";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import AvField from "../../shared/component/form/AvField";
import {RadioButton} from "primereact/radiobutton";
import ProductService from "../../shared/service/ProductService";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import Loading from "../../shared/component/others/Loading";
import Dialog from "../../shared/component/dialog/Dialog";
import PurchaseOrderItemMobileSave from "./PurchaseOrderItemMobileSave";
import CalculationUtils from "../../shared/utils/CalculationUtils";
import Decimal from "../storemanagement/decimal.mjs";

const defaultProduct = {
    id: null,
    bssId: null,

    // fixed
    barcode: null,
    productCode: null,
    generatedProductCode: null,
    itemName: null,
    boxUnitMeasure: null,       // this is not needed, included if needed later
    itemUnitMeasure: null,
    itemSize: null,
    taxRate: null,
    weighable: false,           // default is false

    // variable
    orderQuantity: null,
    deliveryQuantity: null,
    boxSize: null,
    unitPrice: null,
    totalPrice: null,
    taxPrice: null,
    discount: null,
    taxAmount: null,

    // optional / calculated / future fields
    itemBssId: null,
    salePrice: null,
    profitMargin: null,
    expiryDate: null,
    orjDescription: null,
    itemClosed: false,
    barcodeIsSearched: false,
    tillPriceCalculationMethod: null,
    newCodedProduct: false,
    printQueueTillUserBssId: null,
    maxOrjStock: null,
    maxStock: null,
    minStock: null,
    status: 'ACTIVE',
    priceMark: null,
    currentBoxPrice: null,
    currentBoxSize: null,
    currentUnitCost: null
};
export default class PurchaseOrderMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInvoiceLicense: false,
            filterOption: "Barcode",
            disabledFields: true,
            loading: false,
            product: Object.assign({}, defaultProduct),
            id: "",
            purchaseOrderList: [],
            purchaseOrderItemList: [],
            displayDialog: false,
            selectedInvoiceId: "",
            defaultCostPricePercentage: 0
        }
        this.licenseService = new LicenseService();
        this.purchaseOrderService = new PurchaseOrderService();
        this.productService = new ProductService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.dialogHistoryPushed = false;
        this.ignoreNextPopState = false;
        this.handlePopState = this.handlePopState.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
    }

    componentDidMount() {
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', this.handlePopState);
        window.__purchaseOrderMobileBack = this.handleBackButton;

        this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        defaultCostPricePercentage: response.defaultCostPricePercentage != null ? response.defaultCostPricePercentage : 0
                    });
                }
            });

        const savedFilter = sessionStorage.getItem("purchaseOrderMobile.filterOption");
        const savedInvoiceId = sessionStorage.getItem("purchaseOrderMobile.selectedInvoiceId");
        if (savedFilter || savedInvoiceId) {
            this.setState({
                filterOption: savedFilter || this.state.filterOption,
                selectedInvoiceId: savedInvoiceId || ""
            });
        }

        const skipRedirect = sessionStorage.getItem("purchaseOrderMobile.skipRedirectToSave");
        if (skipRedirect === "true") {
            sessionStorage.removeItem("purchaseOrderMobile.skipRedirectToSave");
        }
        if (!skipRedirect && !GeneralUtils.isNullOrEmpty(savedInvoiceId) && window.location.href.indexOf("purchaseOrderMobileSave") === -1) {
            window.location.href = "#purchaseOrderMobileSave?" + savedInvoiceId;
            return;
        }

        this.licenseService.getLicenses(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                if (response.hasInvoiceLicense == true && response.remainingCredit != null && response.remainingCredit > 0) {
                    this.findAllOpens()

                } else {
                    return toast.warn("You don't have an invoice license or your credit has run out.");
                }
            } else {
                return toast.warn("You don't have an invoice license or your credit has run out.");

            }
        });

    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
        if (window.__purchaseOrderMobileBack === this.handleBackButton) {
            delete window.__purchaseOrderMobileBack;
        }
    }

    renderFilter() {
        const isMobile = GeneralUtils.isMobile();

        return (
            <div
                style={{
                    display: 'flex',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    gap: '16px',
                    alignItems: 'center',
                    marginBottom: '12px'
                }}
            >
                {/* BARCODE */}
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                    <RadioButton
                        inputId="Barcode"
                        name="filter"
                        value="Barcode"
                        onChange={this.handleFilterChange}
                        checked={this.state.filterOption === "Barcode"}
                    />
                    <label htmlFor="Barcode" style={{ cursor: 'pointer' }}>
                        Barcode
                    </label>
                </div>

                {/* INVOICE */}
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                    <RadioButton
                        inputId="Invoice"
                        name="filter"
                        value="Invoice"
                        onChange={this.handleFilterChange}
                        checked={this.state.filterOption === "Invoice"}
                    />
                    <label htmlFor="Invoice" style={{ cursor: 'pointer' }}>
                        Invoice
                    </label>
                </div>
            </div>
        );
    }


    handleFilterChange = (e) => {
        const updates = { filterOption: e.value };
        if (e.value === "Barcode") {
            updates.selectedInvoiceId = "";
            sessionStorage.removeItem("purchaseOrderMobile.selectedInvoiceId");
        }
        this.setState(updates, () => {
            sessionStorage.setItem("purchaseOrderMobile.filterOption", e.value);
            this.clearFields();
        });
    };

    findAllOpens() {
        this.purchaseOrderService.findAllOpens().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({purchaseOrderList: response});
            }
        });

    }

    render() {
        return (
            <div>
                <AvForm onSubmit={(e) => e.preventDefault()}>
                    {this.renderFilter()}

                    {this.state.filterOption === "Invoice" &&
                        this.renderInvoiceCombo()
                    }
                    {this.state.filterOption === "Barcode" &&
                        this.renderBarcodeFields()
                    }
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    renderInvoiceCombo() {
        return (
            <div>


                <Fieldset legend="Open Invoice List">

                    <AvGroup>

                        <AvField
                            type="select"
                            disabled={false}
                            className="form-control"
                            name="summaryString"
                            value={this.state.selectedInvoiceId}
                            onChange={this.__handleChangeCombo}>

                            <option value='' key=''/>
                            {this.state.purchaseOrderList.map(element => (<option value={element.id} key={element.id}>
                                {element.summaryString}
                            </option>))}
                        </AvField>

                    </AvGroup>


                </Fieldset>
            </div>)
    }

    renderBarcodeFields() {
        return (
            <div>
                <Fieldset legend="Product">
                    <Row className="align-items-center">
                        {/* Barcode */}
                        <Col xs="9" sm="10" style={{paddingRight: 0}}>
                            <AvGroup>
                                <Label for="barcode">
                                    <Translate contentKey="purchaseOrderItem.barcode">Barcode</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    name="barcode"
                                    id="barcode"
                                    innerRef={(el) => (this.barcodeRef2 = el)}
                                    disabled={false}
                                    className="form-control"
                                    value={this.state.product.barcode}
                                    onChange={this.__handleChange}        // normal value değişikliği
                                    onKeyDown={this._handleEnterKeyDown} // masaüstü enter
                                    onInput={this._handleEnterInput}     // mobil enter/done
                                    autoComplete="off"
                                    enterKeyHint="done"
                                />

                            </AvGroup>

                        </Col>

                        <Col xs="3" sm="2" style={{paddingLeft: 0}}>
                            <div className="d-flex gap-1 align-items-center">
                                <div style={{width: '50%'}} />
                                <Button
                                    type="button"
                                    color="outline-primary"
                                    disabled={false}
                                    style={{width: '50%', padding: '4px', marginLeft: "4px"}}
                                    onClick={() => {
                                        this.clearFields(true);
                                    }}
                                >
                                    <i className="pi pi-times"></i>
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    <Row className="align-items-center" style={{marginBottom: 0}}>
                        {/* Item Name (solda büyük alan) */}
                        <Col xs="9" sm="10" style={{paddingRight: 0}}>
                            <AvGroup style={{marginBottom: 0}}>
                                <Label for="itemName" style={{marginBottom: '0.25rem'}}>
                                    <Translate contentKey="purchaseOrderItem.itemName">Name</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    name="itemName"
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={this.state.product.itemName}
                                    onChange={this.__handleChange}
                                    style={{margin: 0, padding: '0.25rem'}}
                                />
                            </AvGroup>
                        </Col>

                        {/* Butonlar (aynı sütun içinde yan yana) */}
                        <Col xs="3" sm="2" style={{paddingLeft: 0}}>
                            <div className="d-flex gap-1 align-items-center">
                                <Button
                                    type="button"
                                    color="outline-primary"
                                    disabled={this.state.disabledFields}
                                    style={{width: '50%', padding: '4px', marginLeft: "4px"}}
                                    onClick={() => {
                                        const itemName = this.state.product.itemName;
                                        if (!GeneralUtils.isNullOrEmpty(itemName)) {
                                            this.setState({loading: true});
                                            this.getItemList(itemName);
                                        } else {
                                            toast.warn("Fill the name field to search");
                                            this.setState({purchaseOrderItemList: []});
                                        }
                                    }}
                                >
                                    <i className="pi pi-search"></i>
                                </Button>

                                <Button
                                    type="button"
                                    color="outline-primary"
                                    disabled={false}
                                    style={{width: '50%', padding: '4px'}}
                                    onClick={this.clearItemNameOnly}
                                >
                                    <i className="pi pi-times"></i>
                                </Button>
                            </div>
                        </Col>
                    </Row>


                    <Dialog
                        visible={this.state.displayDialog}
                        onHide={this.closeDisplayDialog}
                        className="full-screen-dialog"
                        appendTo={document.body}
                        modal={true}
                        draggable={false}
                        resizable={false}

                    >

                        <PurchaseOrderItemMobileSave ref={(elem) => this.refModelSave = elem}
                                                     refreshDataTable={this.refreshDataTable}
                                                     calculateFields={this.calculateFields}
                                                     deleteItemData={this.deleteItemData}
                                                     clearFields={this.clearFields}
                                                     openNextItem={this.openNextItem}
                                                     updatePurchaseOrderItem={this.updatePurchaseOrderItem}
                                                     updatePurchaseOrderItemAndNext={this.updatePurchaseOrderItemAndNext}
                                                     updatePurchaseOrderItemAndNextUnmatched={this.updatePurchaseOrderItemAndNextUnmatched}
                                                     closePurchaseOrderItemAndNext={this.closePurchaseOrderItemAndNext}
                                                     closePurchaseOrderItemAndNextUnmatched={this.closePurchaseOrderItemAndNextUnmatched}
                                                     closeDisplayDialog={this.closeDisplayDialog}/>
                    </Dialog>


                    <DataTableWithButton ref={(elem) => this.refDataTable = elem}
                                         fields={PurchaseOrderItemMobileListColumn.fields}
                                         objectName={PurchaseOrderItemMobileListColumn.name}
                                         data={this.state.purchaseOrderItemList}
                                         selectionMode='single'
                                         paginator={true}
                                         rows={50}
                                         style={{marginTop: "10px"}}
                                         onDataSelect={this.search}
                                         loading={this.state.loading}/>

                </Fieldset>
            </div>
        );
    }


    getItemList = async (searchValue, options = {}) => {
        const { isBarcodeSearch = false } = options;
        this.setState({loading: true});
        try {
            const response = await this.purchaseOrderService.findAllOpensByDescription(searchValue);
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                const list = response.map((item) => ({
                    ...item,
                    barcodeIsSearched: isBarcodeSearch
                }));
                this.setState({purchaseOrderItemList: list, loading: false});
                return list;
            }
        } catch (e) {
            // ignore
        }
        this.setState({purchaseOrderItemList: [], loading: false});
        return [];
    }

    calculateFields = (product, field) => {
        try {
            const newProduct = {...product};
            const HUNDRED = new Decimal(100);

            if (field === "barcode") {
                newProduct['ItemBssId'] = null;
                newProduct['barcodeIsSearched'] = false;
            }

            newProduct['recommendedSalePrice'] = null;
            newProduct['actualMargin'] = null;
            newProduct['unitCost'] = null;
            newProduct['costPrice'] = null;
            newProduct['taxPrice'] = null;

            if (GeneralUtils.isNullOrEmpty(newProduct['barcode'])) {
                newProduct['itemBssId'] = null;
            }

            const boxQty = new Decimal(newProduct.boxSize || 1);
            const deliveryQuantity = new Decimal(newProduct.deliveryQuantity || 1);
            const totalPrice = new Decimal(newProduct.totalPrice || 0.0);
            const profitMargin = new Decimal(newProduct.profitMargin || 0.0);
            const vatRate = new Decimal(newProduct.taxRate || 0.0);

            // boxPrice = totalPrice / deliveryQuantity
            const boxPrice = deliveryQuantity.isZero()
                ? new Decimal(0)
                : totalPrice.div(deliveryQuantity).toDecimalPlaces(6);

            newProduct['boxPrice'] = parseFloat(
                boxPrice.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
            );

            // Cur. Unit Cost - hesaplanan alan (currentBoxPrice / currentBoxSize veya boxSize)
            const divisorForUnitCost = newProduct.currentBoxSize ?? newProduct.boxSize;
            if (
                newProduct.currentBoxPrice != null &&
                divisorForUnitCost != null &&
                Number(divisorForUnitCost) !== 0
            ) {
                newProduct.currentUnitCost = parseFloat(
                    new Decimal(newProduct.currentBoxPrice)
                        .div(new Decimal(divisorForUnitCost))
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
                        .toString()
                );
            } else {
                newProduct.currentUnitCost = null;
            }

            // ------------------------------------------
            //  ESKİ unitCost HESAPLAMA (DEĞİŞMEDİ)
            // ------------------------------------------

            let unitCost;
            if (boxPrice == null || boxQty == null || boxQty.isZero()) {
                unitCost = new Decimal(0);
            } else {
                unitCost = boxPrice
                    .div(boxQty)
                    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            }

            newProduct['unitCost'] = parseFloat(unitCost.toString());

            let costPrice = new Decimal(0);
            let taxPrice = new Decimal(0);

            if (this.state.license?.includeTax) {
                costPrice = unitCost.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                if (!costPrice.isZero() && !vatRate.isZero()) {
                    taxPrice = costPrice.times(vatRate)
                        .div(HUNDRED.plus(vatRate))
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                } else {
                    taxPrice = new Decimal(0);
                }
            } else {
                const vatMultiplierPrecise = vatRate.plus(HUNDRED).div(HUNDRED).toDecimalPlaces(6);
                if (unitCost.isZero()) {
                    costPrice = new Decimal(0);
                    taxPrice = new Decimal(0);
                } else {
                    costPrice = unitCost.times(vatMultiplierPrecise).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                    taxPrice = costPrice.minus(unitCost)
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                }
            }

            newProduct['costPrice'] = parseFloat(costPrice.toString());
            newProduct['taxPrice'] = parseFloat(taxPrice.toString());

            const marginMultiplier = profitMargin.plus(HUNDRED).div(HUNDRED);
            let recommendedSalePrice = costPrice.times(marginMultiplier).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

            const method =
                newProduct.tillPriceCalculationMethod && newProduct.tillPriceCalculationMethod.trim() !== ""
                    ? newProduct.tillPriceCalculationMethod
                    : this.state.license?.tillPriceCalculationMethod;

            if (method) {
                switch (method) {
                    case "NEAREST_9":
                        recommendedSalePrice = CalculationUtils.roundNearest9(recommendedSalePrice);
                        break;
                    case "NEAREST_49_99":
                        recommendedSalePrice = CalculationUtils.roundNearest49_99(recommendedSalePrice);
                        break;
                    case "NEAREST_00":
                        recommendedSalePrice = CalculationUtils.roundNearest00(recommendedSalePrice);
                        break;
                    case "NEAREST_50":
                        recommendedSalePrice = CalculationUtils.roundNearest50(recommendedSalePrice);
                        break;
                }
            }

            newProduct['recommendedSalePrice'] = parseFloat(recommendedSalePrice.toString());

            if (method !== "PRICE_MARK" && method !== "MANUAL_ENTRY") {
                if (newProduct.oldPrice != null && recommendedSalePrice < newProduct.oldPrice) {
                    newProduct['salePrice'] = newProduct.oldPrice;
                } else if (
                    newProduct.oldPrice != null &&
                    newProduct.oldPrice !== 0 &&
                    newProduct.currentUnitCost != null &&
                    newProduct.currentUnitCost !== 0 &&
                    newProduct.unitCost != null &&
                    newProduct.unitCost !== 0 &&
                    new Decimal(newProduct.currentUnitCost)
                        .minus(new Decimal(newProduct.unitCost))
                        .abs()
                        .lte(
                            new Decimal(newProduct.currentUnitCost)
                                .abs()
                                .times(new Decimal(this.state.defaultCostPricePercentage ?? 0))
                                .div(HUNDRED)
                        )
                ) {
                    // currentActualMargin: eski fiyat / Cur. Unit Cost
                    const currentActualMargin = new Decimal(newProduct.oldPrice)
                        .div(new Decimal(newProduct.currentUnitCost))
                        .times(HUNDRED)
                        .minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                    // newActualMargin: yeni fiyat / Unit Cost
                    const newActualMargin = recommendedSalePrice
                        .div(new Decimal(newProduct.unitCost))
                        .times(HUNDRED)
                        .minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                    // tolerans: mevcut marjın ±%10'u (örn. 40 → 36–44, 50 → 45–55)
                    const tolerance = currentActualMargin.abs().times(0.10);
                    const diff = newActualMargin.minus(currentActualMargin).abs();

                    if (diff.lte(tolerance)) {
                        newProduct['salePrice'] = newProduct.oldPrice;
                    } else {
                        newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                    }
                } else {
                    newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                }
            }

            const itemPrice = new Decimal(newProduct.salePrice || 0.0);
            if (!costPrice.isZero()) {
                newProduct['actualMargin'] = parseFloat(
                    itemPrice.div(costPrice).times(HUNDRED).minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
                );
                if (newProduct.salePrice === newProduct.recommendedSalePrice) {
                    newProduct['actualMargin'] = newProduct.profitMargin;
                }
            } else {
                newProduct['actualMargin'] = 0;
            }

            const profit = (new Decimal(newProduct.salePrice || 0))
                .minus(unitCost)
                .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            newProduct['profit'] = parseFloat(profit.toString());

            return newProduct;

        } catch (e) {
            console.error("calculateFields error:", e);
            return {...product};
        }

    }

    search = async (data) => {

        this.purchaseOrderService.findById(data.invoiceId).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                var item = response.itemList.find(i => i.id === data.id);
                if (item) {
                    let tempItem = null;
                    if (this.state.product.itemBssId == null) {
                        tempItem = item;
                        tempItem.barcode = this.state.product.barcode;
                        tempItem.barcodeIsSearched = true;
                    } else {
                        tempItem = this.convertProductDTOToItemDto(item);
                    }

                    this.pushDialogHistory();
                    GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => {
                        ref.setDisplaySplitButton(false);
                        ref.setData(tempItem, response.purchaseOrderStatus, response.invoiceType, true, response.tillPriceCalculationMethod, response.printQueueTillUserBssId);
                    });
                } else {
                    return toast.warn("")
                }


            }

        });

    }
    convertToDto = async (response) => {
        let product = this.state.product;
        product.itemName = response.name;
        product.itemBssId = response.bssId;
        product.barcode = response.barcode;
        product.itemSize = response.quantity;
        product.taxRate = (response.taxRate ?? response.departmentTaxRate);
        product.weighable = response.weighable;
        product.oldPrice = response.price;
        product.currentBoxPrice = response.costPrice;
        product.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
        product.status = "ACTIVE";
        product.barcodeType = response.barcodeType;
        product.barcodeDigit = response.barcodeDigit;
        product.codeLength = response.codeLength;

        product.profitMargin = response.profitMargin ?? 40;
        product.itemUnitMeasure = response.unit;
        product.boxUnitMeasure = response.boxUnit;
        if (response.minStock != null && response.minStock !== 0) {
            product.minStock = response.minStock;
        } else {
            product.minStock = await this.getDefaultMinStock();
        }

        if (response.maxStock != null && response.maxStock !== 0) {
            product["maxStock"] = response.maxStock;
            product["maxOrjStock"] = response.maxStock;
        } else {
            const deliveryQuantity = product.deliveryQuantity || 0;
            const boxSize = product.boxSize || 0;
            product["maxStock"] = deliveryQuantity * boxSize;
            product["maxOrjStock"] = null;
        }


        product.departmentId = response.departmentId;
        product.barcodeIsSearched = true;
        product.newCodedProduct = false;


        this.setState({product: product});


    }
    convertProductDTOToItemDto = (data) => {
        const product = this.state.product; // this.state.product içinde convertToDto ile set edilmiş alanlar

        // data'nın üzerine product alanlarını kopyala
        data.itemName = product.itemName;
        data.itemBssId = product.itemBssId;
        data.barcode = product.barcode;
        data.itemSize = product.itemSize;
        data.taxRate = product.taxRate;
        data.weighable = product.weighable;
        data.oldPrice = product.oldPrice;
        data.currentBoxPrice = product.currentBoxPrice;
        data.currentBoxSize = product.currentBoxSize;
        data.status = product.status;
        data.barcodeType = product.barcodeType;
        data.barcodeDigit = product.barcodeDigit;
        data.codeLength = product.codeLength;
        data.profitMargin = product.profitMargin;
        data.itemUnitMeasure = product.itemUnitMeasure;
        data.boxUnitMeasure = product.boxUnitMeasure;
        data.minStock = product.minStock;
        data.maxStock = product.maxStock;
        data.maxOrjStock = product.maxOrjStock;
        data.departmentId = product.departmentId;
        data.barcodeIsSearched = product.barcodeIsSearched;
        data.newCodedProduct = product.newCodedProduct;

        return data;
    };


    getDefaultMinStock = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.minStock ?? null; // response.minStock varsa al, yoksa null
                }
                return null;
            });
    };

    __handleChangeCombo = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;

        this.setState({selectedInvoiceId: value});
        sessionStorage.setItem("purchaseOrderMobile.filterOption", "Invoice");
        sessionStorage.setItem("purchaseOrderMobile.selectedInvoiceId", value);
        window.location.href = "#purchaseOrderMobileSave?" + value;

    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const name = e.target.name;

        // Barcode alanında sadece rakam kabul et
        if (name === "barcode" && value != null) {
            value = value.toString().replace(/[^0-9]/g, '');
        }

        let product = this.state.product;
        product[name] = value;
        this.setState({product: product});
    }

    _handleEnterKeyDown = (e) => {
        // Barcode inputunda sadece rakam ve temel kontrol tuşlarına izin ver
        if (e.target.name === "barcode") {
            const allowedKeys = [
                "Backspace", "Tab", "Delete",
                "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
                "Home", "End", "Enter"
            ];
            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
            const isAllowedSpecial = allowedKeys.includes(e.key);
            const isShortcut = e.ctrlKey || e.metaKey;

            if (!isDigit && !isAllowedSpecial && !isShortcut) {
                e.preventDefault();
                return;
            }
        }

        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();       // form submit ve focus kaymasını engelle
            this.findByBarcode();     // barcode ile işlem
            if (this.barcodeRef2) this.barcodeRef2.focus();
        }
    };


    _handleEnterInput = (e) => {
        if (e.nativeEvent.inputType === 'insertLineBreak') {
            e.preventDefault();       // odak kaymasını engelle
            this.findByBarcode();     // barcode ile işlem
            if (this.barcodeRef2) this.barcodeRef2.focus();
        }
    };




    findByBarcode() {
        let product = {...this.state.product};

        if (!GeneralUtils.isNullOrEmpty(product.barcode)) {
            product["barcodeIsSearched"] = true;

            this.productService.findProductByBarcodeWithDepos(product.barcode)
                .then(async (response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({disabledFields: false});
                        this.convertToDto(response);
                        const barcodeValue = response.barcode || product.barcode;
                        let barcodeMatches = [];
                        if (!GeneralUtils.isNullOrEmpty(barcodeValue)) {
                            barcodeMatches = await this.getItemList(barcodeValue, {isBarcodeSearch: true});
                        }
                        if (barcodeMatches.length === 0 && !GeneralUtils.isNullOrEmpty(response.name)) {
                            await this.getItemList(response.name);
                        }


                    } else {
                        // Önce barcode ile getItemList ile tekrar dene
                        const barcodeValue = product.barcode;
                        const barcodeMatches = await this.getItemList(barcodeValue, {isBarcodeSearch: true});
                        if (barcodeMatches.length > 0) {
                            this.setState({disabledFields: false});
                        } else {
                            product["newCodedProduct"] = false;
                            product["itemName"] = null;
                            product["itemBssId"] = null;

                            this.setState({disabledFields: false, product: product, purchaseOrderItemList: []});
                            toast.warn("Barcode not Found!");
                        }
                    }
                })
                .catch(() => {
                    this.setState({disabledFields: false});
                    toast.error("Error while searching barcode!");
                });
        }
    }

    /** Barcode sayfasında item listesinden seçimde popup sadece Save ile açılır; item tek tek backend'e gider. */
    updatePurchaseOrderItem = (data) => {
        this.purchaseOrderService.updateItems(data).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.closeDisplayDialog(true);
                const searchValue = this.state.product?.itemName || this.state.product?.barcode;
                if (searchValue) this.getItemList(searchValue);
            }
        }).catch(() => {});
    };

    updatePurchaseOrderItemAndNext = (data) => {
        this.purchaseOrderService.updateItems(data).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.closeDisplayDialog(true);
                const searchValue = this.state.product?.itemName || this.state.product?.barcode;
                if (searchValue) this.getItemList(searchValue);
            }
        }).catch(() => {});
    };

    updatePurchaseOrderItemAndNextUnmatched = (data) => {
        this.updatePurchaseOrderItemAndNext(data);
    };

    closePurchaseOrderItemAndNext = () => {
        this.closeDisplayDialog();
    };

    closePurchaseOrderItemAndNextUnmatched = () => {
        this.closeDisplayDialog();
    };

    refreshDataTable = () => {
        const searchValue = this.state.product?.itemName || this.state.product?.barcode;
        if (searchValue) this.getItemList(searchValue);
    };

    deleteItemData = () => {};
    openNextItem = () => { this.closeDisplayDialog(); };

    closeDisplayDialog = (clearList = false) => {
        this.setState({displayDialog: false});
        if (clearList) {
            this.popDialogHistory();
            this.clearFields(true);
        } else {
            this.dialogHistoryPushed = false;
        }
    }

    /**
     * Sadece ürün adını (itemName) temizler.
     * Barcode alanına dokunmaz ve mevcut barcode değerini korur.
     * İlgili listeyi de temizler ki eski sonuçlar görünmesin.
     */
    clearItemNameOnly = () => {
        this.setState((prevState) => ({
            product: {
                ...prevState.product,
                itemName: null
            },
            purchaseOrderItemList: []
        }));
    }

    clearFields = (focusBarcode = false) => {
        this.setState({
            purchaseOrderItemList: [],
            disabledFields: true,
            loading: false,
            product: Object.assign({}, defaultProduct),
            id: "",
        }, () => {
            if (focusBarcode && this.barcodeRef2) {
                this.barcodeRef2.focus();
            }
        });
    }

    pushDialogHistory = () => {
        if (!this.dialogHistoryPushed) {
            window.history.pushState({dialog: true}, document.title, window.location.href);
            this.dialogHistoryPushed = true;
        }
    };

    popDialogHistory = () => {
        if (this.dialogHistoryPushed) {
            this.ignoreNextPopState = true;
            window.history.back();
            this.dialogHistoryPushed = false;
        }
    };

    handlePopState() {
        if (this.ignoreNextPopState) {
            this.ignoreNextPopState = false;
            return;
        }
        if (this.state.displayDialog) {
            this.setState({displayDialog: false}, () => {
                this.dialogHistoryPushed = false;
                window.history.pushState(null, document.title, window.location.href);
            });
        }
    }

    handleBackButton() {
        if (this.state.displayDialog) {
            this.closeDisplayDialog();
            return true;
        }
        return false;
    }
}

